import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import scmp from 'components/StyledComp';
import DataTables from 'components-desktop/DataTables';

const propTypes = {
  title: PropTypes.string,
  scheduleVisits: PropTypes.array,
};

const defaultProps = {
  title: '',
  scheduleVisits: [],
};

@autobind
class TableEMedNyFailureVisits extends BaseComponent {
  constructor(props) {
    super(props);
  }

  createColumns() {
    return [{
      title: 'Id',
      dataIndex: 'id',
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: 'ascend',
    }, {
      title: 'Date',
      dataIndex: 'dateUsString',
      sorter: (a, b) => a.date - b.date,
    }, {
      title: 'Service Code',
      dataIndex: 'serviceCode',
      sorter: (a, b) => a.serviceCode?.localeCompare(b.serviceCode),
    }, {
      title: 'Patient',
      dataIndex: 'patientName',
      sorter: (a, b) => a.patientName?.localeCompare(b.patientName),
      render: (text, record) => (
        <scmp.A
          width="wrap_content"
          height="wrap_content"
          href={`/patients/patient_profile?id=${record.patientId}`}
          target="_blank"
        >
          {text}
        </scmp.A>
      ),
    }, {
      title: 'Sch. Time',
      dataIndex: 'schTimeString',
      sorter: (a, b) => a.fromTime - b.fromTime,
    }, {
      title: 'Visit Time',
      dataIndex: 'visitInOutString',
      sorter: (a, b) => a.visitIn - b.visitIn,
    }, {
      title: 'eMedNy Status',
      dataIndex: 'eMedNyStatus',
      sorter: (a, b) => a.eMedNyStatus?.localeCompare(b.eMedNyStatus),
      render: (text, record) => (
        <scmp.Span
          width="wrap_content"
          height="wrap_content"
          color="red_light"
          fontSize="12px"
        >
          {text}
        </scmp.Span>
      ),
    }, {
      title: 'Last Submit Error',
      dataIndex: 'eMedNyLastFailResponse',
      sorter: (a, b) => a.eMedNyLastFailResponse?.localeCompare(b.eMedNyLastFailResponse),
      render: (text, record) => record.eMedNyStatus === 'FAILURE' && (
        <Tooltip title={text}>
          <scmp.Span
            width="wrap_content"
            height="wrap_content"
            color="red_light"
            fontSize="12px"
            ellipsis
            display="inline-block"
          >
            {text}
          </scmp.Span>
        </Tooltip>
      ),
    }];
  }

  createDataSource(scheduleVisits) {
    const dataSource = [];
    scheduleVisits.forEach((visit, index) => {
      dataSource.push({
        key: visit.getId(),
        id: visit.getId(),
        date: visit.getLong('date'),
        dateUsString: visit.getString('dateUsString'),
        serviceCode: visit.getRemoteObject('service')?.getString('displayCode'),
        patientId: visit.getLong('patientId'),
        patientName: visit.getString('patientName'),
        fromTime: visit.getLong('fromTime'),
        toTime: visit.getLong('toTime'),
        schTimeString: `${visit.getString('fromTimeString')} - ${visit.getString('toTimeString')}`,
        visitIn: visit.getLong('visitIn'),
        visitOut: visit.getLong('visitOut'),
        visitInOutString: `${visit.getString('visitInString')} - ${visit.getString('visitOutString')}`,
        visitDurationString: visit.getString('visitDurationString'),
        confirmTime: visit.getLong('confirmTime'),
        confirmTimeUsString: visit.getString('confirmTimeUsString'),
        eMedNyStatus: visit.getString('emedNyStatus'),
        eMedNyLastFailResponse: visit.getString('emedNyLastFailResponse'),
      });
    });
    return dataSource;
  }

  renderContent() {
    const { scheduleVisits, title, ...layoutProps } = this.props;

    return (
      <DataTables
        {...layoutProps}
        ref={(ref) => { this.dataTables = ref; }}
        color="purple_wisteria"
        fontSize="12px"
        size="small"
        title={title}
        icon="cloud-upload"
        withColumnFilter={false}
        columns={this.createColumns()}
        dataSource={this.createDataSource(scheduleVisits)}
      />
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
TableEMedNyFailureVisits.propTypes = propTypes;
TableEMedNyFailureVisits.defaultProps = defaultProps;

export default TableEMedNyFailureVisits;
